import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { RoutePath } from 'shared/constants/router';

import { Button } from './components/Button';

import type { FC } from 'react';

export const StopAdminViewButton: FC = () => {
  const { t } = useTranslation();

  return (
    <Button
      component={Link}
      to={RoutePath.StudentObserver}
      variant="outlined"
      size="small"
    >
      {t('entities.stopAdminViewButton')}
    </Button>
  );
};
